@if (!isLoading) {
  <div
    class="receipt-content {{
      info?.status === orderStatus.Deleted ||
      info?.status === orderStatus.RejectedBySystem ||
      info?.status === orderStatus.RejectedByManager ||
      info?.status === orderStatus.Draft ||
      (info?.status === orderStatus.Waiting &&
        info.transactionType !== transactionType.EtfWalletDeposit &&
        info.transactionType !== transactionType.EtfWalletWithdrawal) ||
      (info?.transactionType === 'Sell' && info?.investmentType === 'ETF')
        ? 'no-price'
        : ''
    }}"
  >
    <ui-ngx-payment-result
      [showActionButton]="false"
      [showBackIcon]="true"
      (onBackIconClick)="onBackClicked()"
      [trackingCode]="info?.receiptNumber || '0'"
      [paymentResult]="paymentResult"
    >
    </ui-ngx-payment-result>
  </div>
} @else {
  <div class="loading-container">
    <app-spinner></app-spinner>
  </div>
}
